import Vue from 'vue';

export enum JumpToEventBusEvents {
  JumpToNavigation = 'jump_to_navigation',
  JumpToFooter = 'jump_to_footer',
}

export const JumpToEventBus = new Vue();
